type Configuration = {
    AUTH_CLIENT_ID: string;
    AUTH_AUTHORITY: string;
    AUTH_TENANT_ID: string;
    AUTH_LOGIN_REQUEST_SCOPE: string;
    API_BASE_URL: string;
    WS_BASE_URL: string;
    USER_ROLE_FOR_ADMIN: string;
};

export const configuration = (window as any).__rivelConfig as Configuration;